import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../bread';
import logoimg from '../../assets/images/logo.png';
import transp from '../../assets/images/esic.png';
import '../../styles/header.scss';
import { slide as Menu } from 'react-burger-menu'

function Header() {
    const [breadOn, setBreadOn] = useState();
    const [pathName, setPathName] = useState(window.location.pathname)
    const [breadcrumbItems, setBreadcrumItems] = useState()


    const iniciaBread = async () => {
        if (pathName == "/transparencia") {
            setBreadOn(false)
        } else {
            setBreadOn(true)
            await setaBread(pathName);
        }
    }

    const setaBread = async (path) => {
        switch (path) {
            case "/transparencia/ouvidoria/estatisticas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Estatísticas do E-SIC', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/listar":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Consultar Requisição', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/leis":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Legislação Relacionada ao Acesso à Informação', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/comopedir":
            case "/transparencia/ouvidoria/comoacompanhar":
            case "/transparencia/ouvidoria/recurso":
            case "/transparencia/ouvidoria/manuais":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Manual do E-SIC', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/cadastrar":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Cadastrar Requisição', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/informacoes":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Institucional e Prazos', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/sigilo":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Informações postas sob sigilo', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/desclassificadas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Informações desclassificadas', active: true }
                ]);
                break;
            case "/transparencia/ouvidoria/publicas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Pedidos de Informação', active: true }
                ]);
                break;
            default:
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', active: true }
                ]);
                break;
        }
    }

    useEffect(() => {
        iniciaBread();
    }, []);


    return (
        <Fragment>
            <header className='header'>
                <Row xs={2} lg={3}>
                    <Col xs={10} lg={3}>
                        <a href="/transparencia" alt="Portal da Transparência do Município de Macuco">
                            <img src={logoimg} className='logo' alt="Portal da Transparência do Município de Macuco" />
                        </a>
                    </Col>
                    <Col xs={10} lg={5}>
                        <a href="/transparencia/ouvidoria" alt="Sistema Eletrônico de Serviço de Informação ao Cidação de Macuco">
                            <img src={transp} className='transp' alt="Sistema Eletrônico de Serviço de Informação ao Cidação de Macuco" />
                        </a>
                    </Col>
                </Row>
                {breadOn ?
                    <Fragment>
                        <Row>
                            <Col xs={{ span: 10, offset: 1 }}>
                                <Breadcrumb items={breadcrumbItems} />
                            </Col>
                        </Row>
                    </Fragment> : ''
                }
                <Menu right>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br">Site da Prefeitura</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia">Portal da Transparência</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/manuais">Manuais de uso</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/sigilo">Informações com sigilo</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/desclassificadas">Informações desclassificadas</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/publicas">Todos pedidos de informação</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/estatisticas">Relatórios e Estatísticas do SIC</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/informacoes">Informações e Prazos do SIC</a>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/leis">Regulamentação do LAI</a>
                </Menu>
            </header>
        </Fragment >

    )
}

export default Header;